import api from "@/api";

const BASE = "/api/tam-ung-luong";

export default {
  // ===== USER =====
  createMy(payload) {
    // payload: { soTien, ghiChu? }
    return api.post(`${BASE}/my`, payload);
  },
  myList(params) {
    // params: { from?, to?, status?, page?, size? }
    return api.get(`${BASE}/my`, { params });
  },
  cancelMy(id) {
    return api.post(`${BASE}/my/${id}/cancel`);
  },

  // ===== ADMIN =====
  adminList(params) {
    // params: { from?, to?, status?, keyword?, userId?, page?, size? }
    return api.get(`${BASE}/admin`, { params });
  },
  approve(id, payload) {
    // payload: { ghiChuAdmin? }
    return api.post(`${BASE}/admin/${id}/approve`, payload || {});
  },
  reject(id, payload) {
    // payload: { lyDoTuChoi? }
    return api.post(`${BASE}/admin/${id}/reject`, payload || {});
  },
  uploadProof(id, formData) {
    // formData: file=...
    return api.post(`${BASE}/admin/${id}/proof`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
